import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../components/maintenance/view/view";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as newsActions from "../../../redux/actions/news";
// Styles
import "./view.css";

const NewsView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);
  const user = useSelector(state => state.authReducer.user);

  // Set consts and vars
  const page = "news";
  const itemNameSingular = "Notícia";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
  }, []);

  // Set grid config
  const filters = [
    `id`,
    `title`,
    `date`,
    `priority`,
    `author`,
    `url_web`,
    `category`,
    `enabled`,
  ];
  const sorters = filters;
  const columns = [
    { 
      name: "files_1",
      width: `100px`,
      header: {
        dataType: "image",
        placeholder: "Imatge",
        textAlign: "center",
        disabled: true,
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
      }
    },
    { 
      name: "id",
      width: `80px`,
      header: {
        dataType: "integer",
        placeholder: "Id",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "title",
      header: {
        dataType: "string",
        placeholder: "Títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "date",
      width: `150px`,
      header: {
        dataType: "date",
        placeholder: "Data",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "priority",
      width: `120px`,
      header: {
        dataType: "integer",
        placeholder: "Prioritat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "category",
      width: `200px`,
      header: {
        dataType: "string",
        placeholder: "Categoria",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "author",
      width: `200px`,
      header: {
        dataType: "string",
        placeholder: "Autor",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "url_web",
      width: `200px`,
      header: {
        dataType: "url",
        placeholder: "URL web",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "enabled",
      width: `105px`,
      header: {
        dataType: "boolean",
        placeholder: "Habilitat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="news-view-content">
        <MaintenanceView 
          primaryKey={"id"}
          primaryNameKey={"title"}
          menuConfig={{
            buttonNew: { visible: !!user && user.grants.news },
            buttonEdit: { visible: !!user && user.grants.news },
            buttonDelete: { visible: !!user && user.grants.news },
          }}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Llista de <b>NOTICIES</b>",
            forceRefreshDataAtBegining: true,
            enablePagination: true,
          }}
          reducerName="newsReducer"
          itemNameSingular={itemNameSingular}
          itemIsMale={false}
          actions={newsActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          isMultiRowSelection={true}
          page={"news"}
        />
      </div>
    </MainLayout>
  );
};

export default NewsView;
